import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { StyledReceiptHeaderImage } from '../../ReceiptHeaderImage/styles/receipt-header-image.styled';
export const receiptHeaderStyles = ({ theme, $colorContext, }) => css `
	display: flex;
	flex-direction: column;
	padding-top: ${pxToRem(theme.spacing[300])};
	background-color: ${$colorContext === 'on-light'
    ? theme.colors.blanc.bgReceipt
    : theme.colors.blanc.bgReceiptOnMedium};
	border: ${theme.borderWidth['1']}px solid ${theme.colors.blanc.bgReceipt};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		padding-top: ${pxToRem(theme.spacing[400])};
		border-bottom: none;
		border-top-left-radius: ${pxToRem(theme.borderRadius.m)};
		border-top-right-radius: ${pxToRem(theme.borderRadius.m)};

		&:has(${StyledReceiptHeaderImage}) {
			padding-top: 0;
		}
	}
`;
export const StyledReceiptHeader = styled.header `
	${receiptHeaderStyles}
`;
